import AbstractDataBuilder from "../../core/AbstractDataBuilder";
import BeginCheckoutNormalizersResolver from "./BeginCheckoutNormalizersResolver";
export default class BeginCheckoutDataBuilder extends AbstractDataBuilder {
    static create() {
        if (undefined === this.builderInstance) {
            this.builderInstance = new this(new BeginCheckoutNormalizersResolver());
        }
        return this.builderInstance;
    }
}
